import { useMemo } from 'react'

import { useIdentity } from '../adapters/Identity'

import type { RootStore } from './useRootStore'
import { useTimeSpentEvents } from './useRootStore'

export function useImpersonateAwareStore(editableStore: RootStore) {
  const [identity] = useIdentity()
  const userTimeSpentEvent = useTimeSpentEvents(identity?.id)

  const readonlyStore = useMemo(() => {
    return {
      state: userTimeSpentEvent.events,
      dispatch: () => {},
    }
  }, [userTimeSpentEvent.events])

  const currentStore = useMemo(() => {
    if (identity?.impersonated) return readonlyStore
    return editableStore
  }, [identity?.impersonated, readonlyStore, editableStore])

  return currentStore
}
